<template>
  <div class="e4s-flex-column e4s-input--container">
    <span class="dat-e4s-input--info-label" v-if="showLabel">
      <slot name="label">
        <label :class="formLabelClass" :style="'visibility:' + (hideLabel ? 'hidden' : '')">
          <span v-text="formLabel"></span>
          <slot name="after-label"></slot>
        </label>
      </slot>
      <div
        v-if="showHelp"
        @click="helpClicked"
        class="e4s-flex-column e4s-flex-center e4s-justify-flex-center dat-e4s-input--info-icon-container"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
          <path
            d="M12,6A6,6,0,1,1,6,0a6,6,0,0,1,6,6ZM4.928,4.525h-.99A1.84,1.84,0,0,1,6,2.625c1.048,0,2,.548,2,1.68a1.831,1.831,0,0,1-.933,1.543c-.553.419-.758.576-.758,1.115v.266H5.338l-.005-.347a1.708,1.708,0,0,1,.876-1.49c.443-.333.724-.552.724-1.028a.871.871,0,0,0-.986-.876A.957.957,0,0,0,4.928,4.525Zm.938,4.832a.7.7,0,1,1,0-1.4.7.7,0,1,1,0,1.4Z"
          />
        </svg>
      </div>
    </span>
    <!--    v-on="$listeners"-->
    <slot name="field"> Place whatever you want here. </slot>
    <slot name="below-field"></slot>
    <p
      v-if="errorMessage.length > 0"
      class="e4s-body--200 e4s-body--error"
      v-text="errorMessage"
    ></p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  formLabel: {
    type: String,
    default: () => {
      return ''
    }
  },
  formLabelClass: {
    type: String,
    default: () => {
      return 'e4s-input--label'
    }
  },
  errorMessage: {
    type: String,
    default: () => {
      return ''
    }
  },
  showHelp: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  showLabel: {
    type: Boolean,
    default: () => {
      //   If false hides the whole label section, which doesn't
      //  really make sense...you'd just dump an input or whatever
      //  on ui...see "hideLabel"
      return true
    }
  },
  hideLabel: {
    type: Boolean,
    default: () => {
      //  This sets visibility to hidden, so the label + field
      //  still takes up same space...which is most likely
      //  what we are after.
      return false
    }
  }
})

const emit = defineEmits<{
  (e: 'helpClicked'): void
}>()

function helpClicked() {
  emit('helpClicked')
}
</script>
<style>
.form-generic-input-template-v2--input-container {
  margin: 4px 0;
}
</style>
